import {useEffect} from "react";

/**
 * Enables a component to scroll to the top after it has been mounted.
 * For details, refer to https://reactrouter.com/web/guides/scroll-restoration/scroll-to-top.
 */
export function useScrollToTop() {
  const ScrollToTop = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    return null;
  };

  return ScrollToTop;
}
